import Vue from 'vue'
import VueResource from 'vue-resource'
import config from '@/config/index.js'

Vue.use && Vue.use(VueResource)

Vue.http.options.crossOrigin = true
Vue.http.options.emulateJSON = true

function getDataViaApi (path, cb, errorHandler, httpStatusHandler) {
  Vue.http.get(config.getApiPath(path), {
    headers: {
      'requestId': '2',
      'principal': 'a'
    }
  }, {headers: { 'requestId': '1' }}).then((res) => {
    cb(res)
  }, (error) => {
    if (httpStatusHandler) {
      console.log('httpStatusHandler ' + error)
    } else {
      console.log('not statushandler')
      errorHandler()
      // defaultHandlerConnectionError(error)
    }
    if (typeof errorHandler === 'function') {
      console.log('errorhandler')
      // errorHandler(error)
    }
  })
}

function putCredDataViaApi (path, data, token, cb, errorHandler, httpStatusHandler) {
  Vue.http.put(config.getApiPath(path), data, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': 'Bearer ' + token
    }
  }).then((res) => {
    cb(res)
  }, (error) => {
    if (httpStatusHandler) {
      console.log('httpStatusHandler' + error)
    } else {
      console.log('not statushandler')
      errorHandler()
    }
    if (typeof errorHandler === 'function') {
      console.log('errorhandler is function')
    }
  })
}

function getPublicData (path, cb, errorHandler, httpStatusHandler) {
  // const a = 'http://62.72.58.202:1337/api/mkuvalidityusermkus?filters[Username][$eq]=adminventory&filters[Hint][$eq]=adm101'
  Vue.http.get(config.getApiPath(path), {
  // Vue.http.get(a, {
    headers: {
      // 'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MywiaWF0IjoxNzEyNjUzMTcwLCJleHAiOjE3MTUyNDUxNzB9.kBHcGuKpaNuc-kzhz8Nkw0pmbPBK1d0y-dwXlNffd6I'
    }
  }, {headers: { 'requestId': '1' }}).then((res) => {
    cb(res)
  }, (error) => {
    if (httpStatusHandler) {
      console.log('httpStatusHandler ' + error)
    } else {
      console.log('not statushandler')
      errorHandler()
      // defaultHandlerConnectionError(error)
    }
    if (typeof errorHandler === 'function') {
      console.log('errorhandler')
      // errorHandler(error)
    }
  })
}

function authApi (username, password, cb, errorHandler, httpStatusHandler) {
  Vue.http.get(config.getApiPath(config.api.member.signIn), {
    headers: {
      'requestId': username,
      'principal': username,
      'username': username,
      'password': password
    }
  }).then((res) => {
    cb(res)
  }, (error) => {
    if (httpStatusHandler) {
      console.log('httpStatusHandler ' + error)
      // httpStatusHandler(error)
    } else {
      console.log('not statushandler')
      errorHandler()
      // defaultHandlerConnectionError(error)
    }
    if (typeof errorHandler === 'function') {
      console.log('errorhandler')
      // errorHandler(error)
    }
  })
}

function postDataViaApi (path, data, cb, errorHandler, httpStatusHandler) {
  Vue.http.post(config.getApiPath(path), data, {headers: { 'Content-Type': 'application/json' }}).then((res) => {
    cb(res)
  }, (error) => {
    if (httpStatusHandler) {
      console.log('httpStatusHandler ' + error)
      // httpStatusHandler(error)
    } else {
      console.log('not statushandler')
      errorHandler()
      // defaultHandlerConnectionError(error)
    }
    if (typeof errorHandler === 'function') {
      console.log('errorhandler')
      // errorHandler(error)
    }
  })
}

function postCredDataViaApi (path, data, token, cb, errorHandler, httpStatusHandler) {
  Vue.http.post(config.getApiPath(path), data, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    }
  }).then((res) => {
    cb(res)
  }, (error) => {
    if (httpStatusHandler) {
      console.log('httpStatusHandler ' + error)
    } else {
      errorHandler()
    }
    if (typeof errorHandler === 'function') {
      console.log('errorhandler')
    }
  })
}

function deleteCredDataViaApi (path, token, cb, errorHandler, httpStatusHandler) {
  Vue.http.delete(config.getApiPath(path), {
    headers: {
      'Authorization': 'Bearer ' + token
    }
  }, {headers: { 'Authorization': 'no auth' }}).then((res) => {
    cb(res)
  }, (error) => {
    if (httpStatusHandler) {
      console.log('httpStatusHandler ' + error)
    } else {
      console.log('not statushandler')
      errorHandler()
    }
    if (typeof errorHandler === 'function') {
      console.log('errorhandler')
    }
  })
}

function postMessage (path, data, cb, errorHandler, httpStatusHandler) {
  Vue.http.post(config.postMessage(path), data, {headers: { 'Content-Type': 'application/json' }}).then((res) => {
    cb(res)
  }, (error) => {
    if (httpStatusHandler) {
      console.log('httpStatusHandler ' + error)
      // httpStatusHandler(error)
    } else {
      console.log('not statushandler')
      errorHandler()
      // defaultHandlerConnectionError(error)
    }
    if (typeof errorHandler === 'function') {
      console.log('errorhandler')
      // errorHandler(error)
    }
  })
}

function postLoginDataViaApi (path, data, cb, errorHandler, httpStatusHandler) {
  Vue.http.post(config.getApiPath(path), data, {headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}).then((res) => {
    cb(res)
  }, (error) => {
    if (httpStatusHandler) {
      console.log('httpStatusHandler ' + error)
      // httpStatusHandler(error)
    } else {
      console.log('not statushandler')
      errorHandler()
      // defaultHandlerConnectionError(error)
    }
    if (typeof errorHandler === 'function') {
      console.log('errorhandler')
      // errorHandler(error)
    }
  })
}

// function postDataWithImageViaApi (path, data, cb, errorHandler, httpStatusHandler) {
//   console.log('postDataViaApi')
//   Vue.http.post(config.getApiPath(path), data, {headers: { 'Content-Type': undefined }}).then((res) => {
//     cb(res)
//   }, (error) => {
//     if (httpStatusHandler) {
//       console.log('httpStatusHandler ' + error)
//       // httpStatusHandler(error)
//     } else {
//       console.log('not statushandler')
//       errorHandler()
//       // defaultHandlerConnectionError(error)
//     }
//     if (typeof errorHandler === 'function') {
//       console.log('errorhandler')
//       // errorHandler(error)
//     }
//   })
// }

function putDataViaApi (path, data, cb, errorHandler, httpStatusHandler) {
  console.log('putDataViaApi')
  Vue.http.put(config.getApiPath(path), data, {headers: { 'Content-Type': 'application/json' }}).then((res) => {
    cb(res)
  }, (error) => {
    if (httpStatusHandler) {
      console.log('httpStatusHandler' + error)
    } else {
      console.log('not statushandler')
      errorHandler()
      // defaultHandlerConnectionError(error)
    }
    if (typeof errorHandler === 'function') {
      console.log('errorhandler is function')
      // errorHandler(error)
    }
  })
}

function deleteDataViaApi (path, cb, errorHandler, httpStatusHandler) {
  console.log('deleteDataViaApiPost')
  Vue.http.delete(config.getApiPath(path), {headers: { 'Content-Type': 'application/json' }}).then((res) => {
    cb(res)
  }, (error) => {
    if (httpStatusHandler) {
      console.log('httpStatusHandler ' + error)
      // httpStatusHandler(error)
    } else {
      console.log('not statushandler')
      // errorHandler()
      defaultHandlerConnectionError(error)
    }
    if (typeof errorHandler === 'function') {
      console.log('errorhandler is function')
      // errorHandler(error)
    }
  })
}

function defaultHandlerConnectionError (error) {
  console.log('errorStatus: ' + error.status)
  switch (error.status) {
    case 400:
      console.log('handle400error')
      break
    case 500:
      console.log('handle500error')
      break
    default:
      console.log('handleDefaultError')
  }
}

export default {
  sendMessage: (cb, data, errHandler) => {
    const message = 'Ada pesan baru dari ' + data.message.name + '.\nEmail: ' + data.message.email + '.\nNomor: ' + data.message.phoneNumber + '.\nMohon hubungi kontak diatas, terima kasih.'
    var formData = new FormData()
    formData.append('chat_id', '-1002009060463')
    formData.append('text', message)
    // formData.append('data', new Blob([JSON.stringify(data.client)], {type: 'application/json'}))
    // formData.append('image', data.image)
    postMessage(config.api.tel.send, formData, cb, errHandler)
  },
  editProject: (cb, data, errHandler) => {
    // var formData = new FormData()
    // formData.append('data', new Blob([JSON.stringify(data.project)], {type: 'application/json'}))
    // if (data.project.images != null) {
    //   formData.append('addImages', data.project.images)
    // }
    const req = { data: data.project }
    putCredDataViaApi(config.api.project.update + data.id, req, data.token, cb, errHandler)
  },
  editProduct: (cb, data, errHandler) => {
    // var formData = new FormData()
    // formData.append('data', new Blob([JSON.stringify(data.product)], {type: 'application/json'}))
    // if (data.product.images != null) {
    //   formData.append('addImages', data.product.images)
    // }
    const req = { data: data.product }
    putCredDataViaApi(config.api.product.update + data.id, req, data.token, cb, errHandler)
  },
  editContentById: (cb, data, errHandler) => {
    const req = { data: data.content }
    putCredDataViaApi(config.api.content.update + data.id, req, data.token, cb, errHandler)
  },
  deleteProject: (cb, data, errHandler) => {
    deleteCredDataViaApi(config.api.project.delete + data.id, data.token, cb, errHandler)
  },
  deleteProduct: (cb, data, errHandler) => {
    deleteCredDataViaApi(config.api.product.delete + data.id, data.token, cb, errHandler)
  },
  deleteClient: (cb, data, errHandler) => {
    deleteCredDataViaApi(config.api.client.delete + data.id, data.token, cb, errHandler)
  },
  uploadFile: (cb, data, errHandler) => {
    var formData = new FormData()
    formData.append('refId', data.file.refId)
    formData.append('ref', data.file.ref)
    formData.append('field', data.file.field)
    formData.append('files', data.file.files)
    postCredDataViaApi(config.api.upload, formData, data.token, cb, errHandler)
  },
  deleteFile: (cb, data, errHandler) => {
    deleteCredDataViaApi(config.api.upload + '/files/' + data.id, data.token, cb, errHandler)
  },
  createProject: (cb, data, errHandler) => {
    // var formData = new FormData()
    // formData.append('data', new Blob([JSON.stringify(data.project)], {type: 'application/json'}))
    // formData.append('images', data.image)
    const req = { data: data.project }
    postCredDataViaApi(config.api.project.create, JSON.stringify(req), data.token, cb, errHandler)
  },
  createProduct: (cb, data, errHandler) => {
    // var formData = new FormData()
    // formData.append('data', new Blob([JSON.stringify(data.product)], {type: 'application/json'}))
    // formData.append('images', data.image)
    const req = { data: data.product }
    postCredDataViaApi(config.api.product.create, JSON.stringify(req), data.token, cb, errHandler)
  },
  createClient: (cb, data, errHandler) => {
    // var formData = new FormData()
    // formData.append('data', new Blob([JSON.stringify(data.client)], {type: 'application/json'}))
    // formData.append('image', data.image)
    const req = { data: data.client }
    postCredDataViaApi(config.api.client.create, JSON.stringify(req), data.token, cb, errHandler)
  },
  getProductList: (cb, data, errHandler) => {
    getPublicData(config.api.product.find + '?pagination[page]=1&pagination[pageSize]=100000&populate=*', cb, errHandler)
  },
  getProjectList: (cb, data, errHandler) => {
    getPublicData(config.api.project.find + '?pagination[page]=1&pagination[pageSize]=100000&populate=*', cb, errHandler)
  },
  findAllClients: (cb, data, errHandler) => {
    getPublicData(config.api.client.find + '?pagination[page]=1&pagination[pageSize]=100000&populate=*', cb, errHandler)
  },
  findContentById: (cb, data, errHandler) => { // by key
    getPublicData(config.api.content.find + '?filters[key][$eq]=' + data.id, cb, errHandler)
  },
  findAllContents: (cb, data, errHandler) => {
    getPublicData(config.api.content.find + '?pagination[page]=1&pagination[pageSize]=100000', cb, errHandler)
  },
  findProjectById: (cb, data, errHandler) => {
    getPublicData(config.api.project.find + '?populate=*&filters[id][$eq]=' + data.id, cb, errHandler)
  },
  findProductById: (cb, data, errHandler) => {
    getPublicData(config.api.product.find + '?populate=*&filters[id][$eq]=' + data.id, cb, errHandler)
  },
  findClientById: (cb, data, errHandler) => {
    getDataViaApi(config.api.client.findById + data.id, cb, errHandler)
  },
  editClient: (cb, data, errHandler) => {
    var formData = new FormData()
    formData.append('data', new Blob([JSON.stringify(data.client)], {type: 'application/json'}))
    if (data.client.images != null) {
      formData.append('addImages', data.client.images)
    }
    postDataViaApi(config.api.client.update + data.client.id, formData, cb, errHandler)
  },
  findAllProjects: (cb, data, errHandler) => {
    if (data.page === undefined || data.page === null) {
      data.page = 0
      data.size = 20
    } else {
      data.size = 20
    }
    var params = []
    params.push('page=' + data.page)
    params.push('size=' + data.size)
    getDataViaApi(config.api.project.find + '?' + params.join('&'), cb, errHandler)
  },
  findAllProducts: (cb, data, errHandler) => {
    if (data.page === undefined || data.page === null) {
      data.page = 0
      data.size = 20
    } else if (data.size === undefined || data.size === null) {
      data.size = 20
    }
    var params = []
    params.push('page=' + data.page)
    params.push('size=' + data.size)
    getDataViaApi(config.api.product.find + '?' + params.join('&'), cb, errHandler)
  },
  addClient: (cb, data, errHandler) => {
    var formData = new FormData()
    formData.append('data', new Blob([JSON.stringify(data.product)], {type: 'application/json'}))
    formData.append('image', data.image)
    postDataViaApi(config.api.product.create, formData, cb, errHandler)
  },
  login: (cb, data, errHandler) => {
    var formData = new FormData()
    formData.append('identifier', data.username)
    formData.append('password', data.password)
    postLoginDataViaApi(config.api.auth.login, formData, cb, errHandler)
  },
  createInquiry: (cb, data, errHandler) => {
    postDataViaApi(config.api.inquiry.create, JSON.stringify(data.inquiry), cb, errHandler)
  },
  getAllInquiries: (cb, data, errHandler) => {
    if (data.page === undefined || data.page === null) {
      data.page = 0
      data.size = 99999
    } else if (data.size === undefined || data.size === null) {
      data.size = 20
    }
    var params = []
    params.push('page=' + data.page)
    params.push('size=' + data.size)
    params.push('sort=id,desc')
    getDataViaApi(config.api.inquiry.find + '?' + params.join('&'), cb, errHandler)
  },
  subscribe: (cb, data, errHandler) => {
    postDataViaApi(config.api.newsletter.subscribe + data.email, cb, errHandler)
  },
  findAllSubscribers: (cb, data, errHandler) => {
    if (data.page === undefined || data.page === null) {
      data.page = 0
      data.size = 20
    } else if (data.size === undefined || data.size === null) {
      data.size = 20
    }
    var params = []
    params.push('page=' + data.page)
    params.push('size=' + data.size)
    getDataViaApi(config.api.newsletter.find + '?' + params.join('&'), cb, errHandler)
  },
  unsubscribe: (cb, data, errHandler) => {
    postDataViaApi(config.api.newsletter.unsubscribe + data.email, cb, errHandler)
  },
  changePassword: (cb, data, errHandler) => {
    console.log('changPassword for username ' + data.member.username)
    postDataViaApi(config.api.member.changePassword, JSON.stringify(data.member), cb, errHandler)
  },
  signUp: (cb, data, errHandler) => {
    console.log('signUp: ' + data.member.username)
    postDataViaApi(config.api.member.signUp, JSON.stringify(data.member), cb, errHandler)
  },
  signIn: (cb, data, errHandler) => {
    console.log('signIn: ' + data.member.username)
    authApi(data.member.username, data.member.password, cb, errHandler)
  },
  getProfile: (cb, data, errHandler) => {
    console.log('getProfile with username: ' + data.username)
    getDataViaApi(config.api.member.profile + data.username, cb, errHandler)
  },
  addAddress: (cb, data, errHandler) => {
    console.log('addAddress with memberId: ' + data.memberId)
    postDataViaApi(config.api.member.addAddress + data.memberId + '/shipping-address', JSON.stringify(data.address), cb, errHandler)
  },
  removeAddress: (cb, data, errHandler) => {
    console.log('removeAddress with memberId: ' + data.memberId + ' and shippingId: ' + data.shippingId)
    deleteDataViaApi(config.api.member.removeAddress + data.memberId + '/shipping-address/' + data.shippingId, cb, errHandler)
  },
  removeCart: (cb, data, errHandler) => {
    console.log('removeCart with cartId: ' + data.cartId)
    deleteDataViaApi(config.api.cart.remove + data.cartId + '/items/' + data.skuCode, cb, errHandler)
  },
  confirmPayment: (cb, data, errHandler) => {
    console.log('confirmPayment with orderId: ' + data.orderId)
    putDataViaApi(config.api.order.confirmPayment + data.orderId, JSON.stringify(data.orderId), cb, errHandler)
  },
  confirmDelivery: (cb, data, errHandler) => {
    console.log('confirmDelivery with orderId: ' + data.orderId)
    putDataViaApi(config.api.order.confirmDelivery + data.orderId, JSON.stringify(data.orderId), cb, errHandler)
  },
  editAddress: (cb, data, errHandler) => {
    console.log('editAddress with memberId: ' + data.memberId + ' and shippingId: ' + data.address.id)
    putDataViaApi(config.api.member.editAddress + data.memberId + '/shipping-address/' + data.address.id, JSON.stringify(data.address), cb, errHandler)
  },
  getProvinceList: (cb, data, errHandler) => {
    console.log('getProvinceList')
    getDataViaApi(config.api.region.provinceList, cb, errHandler)
  },
  getCityList: (cb, data, errHandler) => {
    console.log('getCityList')
    getDataViaApi(config.api.region.cityList + data.stateId + '/cities/', cb, errHandler)
  },
  getDistrictList: (cb, data, errHandler) => {
    console.log('getDistrictList')
    getDataViaApi(config.api.region.districtList + data.cityId + '/districts/', cb, errHandler)
  },
  getSubDistrictList: (cb, data, errHandler) => {
    console.log('getSubDistrictList')
    getDataViaApi(config.api.region.subDistrictList + data.districtId + '/sub-districts/', cb, errHandler)
  },
  getPostalCodeList: (cb, data, errHandler) => {
    console.log('getPostalCodeList')
    getDataViaApi(config.api.region.postalCodeList + data.subDistrictId + '/postal-codes/', cb, errHandler)
  },
  getProductListByName: (cb, data, errHandler) => {
    console.log('getProductListByName')
    getDataViaApi(config.api.product.productListByName + data.categoryName, cb, errHandler)
  },
  getProductDetail: (cb, data, errHandler) => {
    console.log('getProductDetail. data: ' + data.skuCode)
    getDataViaApi(config.api.product.productDetail + data.skuCode, cb, errHandler)
  },
  getAllOutlet: (cb, data, errHandler) => {
    console.log('getAllOutlet')
    if (data.page === undefined || data.page === null) {
      data.page = 0
      data.size = 1000
    } else {
      data.size = 20
    }
    var params = []
    params.push('page=' + data.page)
    params.push('size=' + data.size)
    getDataViaApi(config.api.outlet.getAllOutlet + '?' + params.join('&'), cb, errHandler)
  },
  addToCart: (cb, data, errHandler) => {
    console.log('addToCart with id: ' + data.id)
    postDataViaApi(config.api.cart.addToCart + data.id, JSON.stringify(data.item), cb, errHandler)
  },
  updateCart: (cb, data, errHandler) => {
    console.log('update with id: ' + data.id)
    putDataViaApi(config.api.cart.updateCart + data.id, JSON.stringify(data.item), cb, errHandler)
  },
  checkout: (cb, data, errHandler) => {
    console.log('checkout with id: ' + data.cartId)
    console.log('checkout request outletId: ' + data.checkoutCartRequest.outletId)
    console.log('checkout request paymentMethod: ' + data.checkoutCartRequest.paymentMethod)
    console.log('checkout request shipmentMethod: ' + data.checkoutCartRequest.shipmentMethod)
    console.log('checkout request shippingAddressId: ' + data.checkoutCartRequest.shippingAddressId)
    putDataViaApi(config.api.cart.updateCart + data.cartId + '/checkout', JSON.stringify(data.checkoutCartRequest), cb, errHandler)
  },
  calculateShippingCost: (cb, data, errHandler) => {
    console.log('calculateShippingCost. origin: ' + data.origin + '. destination: ' + data.destination + '. weight: ' + data.weight)
    var params = []
    params.push('origin=' + data.origin)
    params.push('destination=' + data.destination)
    params.push('weight=' + data.weight)

    getDataViaApi(config.api.shipping.calculateShippingCost + '?' + params.join('&'), cb, errHandler)
  },
  getOrderList: (cb, data, errHandler) => {
    console.log('getOrderList. status: ' + data.status + ' uname: ' + data.username)

    var params = []
    params.push('page=' + data.page)
    params.push('size=' + 20)
    params.push('customer.username=' + data.username)
    if (data.status === 'ongoing') {
      params.push('status=M')
      params.push('status=C')
      params.push('status=FP')
      params.push('status=PU')
    } else if (data.status === 'finished') {
      params.push('status=D')
    } else if (data.status === 'cancelled') {
      params.push('status=X')
    }
    params.push('sort=createdDate,desc')
    getDataViaApi(config.api.order.getOrderList + '?' + params.join('&'), cb, errHandler)
  },
  getCartById: (cb, data, errHandler) => {
    console.log('getCartById. data: ' + data.id)
    getDataViaApi(config.api.cart.getCartById + data.id, cb, errHandler)
  },
  getNearestOutlet: (cb, data, errHandler) => {
    console.log('getNearestOutlet')
    var params = []
    params.push('geoLong=' + data.geoLong)
    params.push('geoLat=' + data.geoLat)
    for (let code in data.cartItems) {
      params.push('productCodes=' + data.cartItems[code].skuCode)
    }
    getDataViaApi(config.api.outlet.nearest + '?' + params.join('&'), cb, errHandler)
  },
  getListExample: (cb, data = {page: 1, item_per_page: 10}, errHandler) => {
    console.log('getProfile in member.js')
    var params = []
    params.push('page=' + data.page)
    params.push('size=' + data.size)

    getDataViaApi(config.api.member.profile + 'test@gmail.com', cb, errHandler)
    // success
    // getDataViaApi(config.api.member.profile + '?' + params.join('&'), cb, errHandler)
  },

  getDataViaApi,
  postDataViaApi
}



// WEBPACK FOOTER //
// ./src/api/backend.js